import { Space } from 'antd';
import { USER_TYPE } from 'types/Enum';
import styled from 'utils/styled';

export const Container = styled.div``;

export const StyledSpace = styled(Space)`
  width: 100%;
`;

export const Badge = styled.div<{ type: USER_TYPE }>`
  padding: 4px 8px;
  background-color: ${(props: any) =>
    props.type === 'DISABLED' ? '#e74c3c' : '#2ecc71'};
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;

export const ButtonRow = styled.div`
  display: flex;
  align-items: center;
`;
